import React from 'react';

import './NavigationBar.scss';
import BackButton from '../BackButton';
import NextButton from '../NextButton';
import { useLocation, useParams } from 'react-router-dom';

const NavigationBar = ({ back, next }) => {
  const location = useLocation();
  const { tipo, modelo, version, anio, color } = useParams();
  
  let nextOverride = null;
  if (location.search.indexOf('back') !== -1) {
    nextOverride = `/${tipo}/${modelo}/${version}/${anio}/${color}/resumen/`;
  }

  return (
    <div className="navigation-bar">
      {back && (
        <div className="navigation-bar__back">
          <BackButton to={back} />
        </div>
      )}
      {next && (
        <div className="navigation-bar__next">
          <NextButton to={nextOverride || next} />
        </div>
      )}
    </div>
  )
};

export default NavigationBar;
